import { render, staticRenderFns } from "./schoolModal.vue?vue&type=template&id=386777b2&scoped=true&"
import script from "./schoolModal.vue?vue&type=script&lang=js&"
export * from "./schoolModal.vue?vue&type=script&lang=js&"
import style0 from "./schoolModal.vue?vue&type=style&index=0&id=386777b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386777b2",
  null
  
)

export default component.exports